import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import Tooltip from 'primevue/tooltip'
import Aura from '@primeuix/themes/aura'

import App from './App.vue'
import router from './router'
import { i18n } from './i18n'
import { initSentry } from './config/sentry'

// Styles — Tailwind v4 + shadcn-vue tokens MUST load before app styles
// so PrimeVue (Aura) and shadcn-vue cascade layers compose predictably.
import './assets/styles/tailwind.css'
import 'primeicons/primeicons.css'
import './assets/styles/main.scss'
import './assets/styles/dashboard.css'

const app = createApp(App)

// Sentry — initialize FIRST so subsequent setup errors are captured.
// No-op when VITE_SENTRY_DSN is unset.
initSentry(app, router)

// Pinia (state management)
const pinia = createPinia()
app.use(pinia)

// Vue I18n
app.use(i18n)

// Vue Router
app.use(router)

// PrimeVue
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: '.dark',
    },
  },
})
app.use(ToastService)
app.use(ConfirmationService)
// v-tooltip direktifi (WorksheetsPage/CampsListPage/ExamDetailPage kullanıyor;
// kayıtlı değildi → "Failed to resolve directive: tooltip" konsol uyarıları).
app.directive('tooltip', Tooltip)

// Locale store initialization moved INTO App.vue's onMounted — usePrimeVue()
// requires component context and crashes when called from top-level main.ts.

app.mount('#app')
